export default {
  svgPath: `
    <path fill-rule="evenodd" clip-rule="evenodd" d="M10.5001 11.4143L16.793 17.7072L18.2072 16.293L11.9143 10.0001L18.2072 3.70718L16.793 2.29297L10.5001 8.58587L4.20718 2.29297L2.79297 3.70718L9.08587 10.0001L2.79297 16.293L4.20718 17.7072L10.5001 11.4143Z"/>
  `,
  title: 'x',
  viewBox: '0 0 21 20',
};
